import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useLocation, useNavigate } from "react-router-dom";
import { AddButton } from "../../../../utils/Custom/Button";
import { submitSiteDelete } from "../../../../utils/commonComponent/delete";
import { fetchQuery } from "../../../../utils/commonComponent/fetched";
import ListSearchSection from "../../../../utils/Custom/ListSearchSection";
import ListView from "../../../../utils/Custom/listView";
import { getPermissions } from "../../../Pages/rbac/hasAccess";
import { masterTypes } from "./editMaster";

const headers = ["id", "type", "Value"];

const fields = [
  { value: "type", label: "Type" },
  { value: "Value", label: "Value" },
];

const MasterList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);

  const handleEdit = (row) => navigate(`/talent-acquisition/editMaster/${row.id}`);
  const handleDelete = (row) => submitSiteDelete("talentAcquisitionMaster", row.id);

  const [masterList, setMasterList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "type");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));

  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", page);
    sessionStorage.setItem("ListRowsPerPage", rows);
  };

  const getWhereClause = () => {
    const colMap = {
      type: "type",
      Value: "Value",
    };

    const colName = colMap[searchBy];
    const key = searchKey.trim();
    let whereConditions = ["status != -1"];

    if (colName && key) {
      if (colName === "type") {
        const selected = masterTypes.find(
          (t) => t.name.toLowerCase() === key.toLowerCase()
        );

        if (selected) {
          whereConditions.push(`type = ${selected.id}`);
        } else {
          whereConditions.push("1 = 0");
        }
      } else {
        whereConditions.push(`${colName} LIKE '%${key}%'`);
      }
    }

    return `WHERE ${whereConditions.join(" AND ")}`;
  };

  const getDataQuery = () => {
    const whereClause = getWhereClause();
    const pagination =
      rowsPerPage !== -1
        ? `LIMIT ${rowsPerPage} OFFSET ${rowsPerPage * currentPage}`
        : "";
    return `SELECT * FROM talentAcquisitionMaster ${whereClause} ORDER BY id DESC ${pagination};`;
  };

  const getCountQuery = () => {
    return `SELECT COUNT(*) AS totalRows FROM talentAcquisitionMaster ${getWhereClause()};`;
  };

  const fetchData = async () => {
    try {
      const [data, countResult] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
      ]);

      const mapped = data.map((row) => ({
        ...row,
        type: masterTypes.find((t) => t.id == row.type)?.name || row.type,
      }));

      setMasterList(mapped);
      setTotalRows(countResult?.[0]?.totalRows || 0);
    } catch (error) {
      console.error("Error fetching master data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchData();
    setSearched(true);
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("type");
    setSearchKey("");
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (searched === false) {
      fetchData();
    }
  }, [searched]);

  return (
    <>
      {(permissions.create || permissions.allAccess) && (
        <AddButton
          id="btn-add-master"
          to="/talent-acquisition/editMaster/0"
          label="Add Master"
          icon={<AddIcon fontSize="small" />}
        />
      )}
      <ListSearchSection
        title="Search Master"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
      />
      <ListView
        headers={headers}
        data={masterList}
        actions={{
          edit: handleEdit,
          delete: handleDelete,
        }}
        showCheckbox={true}
        deleteTableName="talentAcquisitionMaster"
        moduleId={props.moduleId}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPaginationChange={handlePaginationChange}
      />
    </>
  );
};

export default MasterList;
